module.exports = __webpack_public_path__ + "img/hr-tree-03-a-leaves.d209ca04.png";